import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ui-sider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  templateUrl: './sider.component.html'
})
export class SiderComponent {
  isCollapsed = input<boolean>();
  onToggle = output();

  toogleIcon = computed(() => this.isCollapsed() ? 'caret-right' : 'caret-left' )

  toggle() {
    this.onToggle.emit()
  }
}
